import { render } from "./UIFlexBox.vue?vue&type=template&id=7952516e"
const script = {}

import "./UIFlexBox.vue?vue&type=style&index=0&id=7952516e&lang=css"

import exportComponent from "C:\\Users\\Owner\\source\\training-generator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__